import UsersMainTableHOC from './UsersMainTableHOC';

export default UsersMainTableHOC;
